<div
  #bingMapContainer
  style="
    width: 100%;
    height: 100%;
    max-height: 730px;
    position: relative;
    overflow: hidden;
  "
></div>
<div></div>
